import { render, staticRenderFns } from "./widget-preview-panel.vue?vue&type=template&id=28282db6&scoped=true&"
import script from "./widget-preview-panel.vue?vue&type=script&lang=js&"
export * from "./widget-preview-panel.vue?vue&type=script&lang=js&"
import style0 from "./widget-preview-panel.vue?vue&type=style&index=0&id=28282db6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28282db6",
  null
  
)

export default component.exports